import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { wellnessBaseUrl } from "network";

export const clinicSlice = createApi({
    reducerPath: "clinicSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: wellnessBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getClinics: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/clinic/list?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        addClinicService: builder.mutation({
            query: (body) => ({
                url: `/clinic/service_linked`,
                method: "POST",
                body,
            }),
        }),

        addClinicLocations: builder.mutation({
            query: (body) => ({
                url: `/clinic/user-area-link`,
                method: "POST",
                body,
            }),
        }),


        // ✅ Delete Category
        deleteClinic: builder.mutation({
            query: (id) => ({
                url: `/clinic/${id}`,
                method: "DELETE",
            }),
        }),

        sendOtpToClinic: builder.mutation({
            query: (body) => ({
                url: "/clinic/sendOtp",
                method: "POST",
                body,
            }),
        }),

        registerClinic: builder.mutation({
            query: (body) => ({
                url: "/clinic/register",
                method: "POST",
                body,
            }),
        }),

        getSingleClinic: builder.query({
            query: (id) => ({
                url: `/clinic/singleDetail/${id}`,
                method: "GET",

            }),
        }),

        unlinkClinicArea: builder.mutation({
            query: (id) => ({
                url: `/clinic/user-area-unlink/${id}`,
                method: "DELETE",
            }),
        }),




    }),
});

export const {
    useGetClinicsQuery,
    useAddClinicServiceMutation,
    useAddClinicLocationsMutation,
    useDeleteClinicMutation,
    useSendOtpToClinicMutation,
    useRegisterClinicMutation,
    useGetSingleClinicQuery, 
    useUnlinkClinicAreaMutation
} = clinicSlice;
